import { Component, computed, input, output } from '@angular/core'
import { EventPowerUpId } from '@app/v2/event/enums/event-power-up-id.enum'
import { MobileCollapsibleSectionComponent } from '@app/v2/shared/components/mobile-collapsible-section/mobile-collapsible-section.component'
import { PowerUpCard, PowerUpCardComponent } from './power-up-card/power-up-card.component'

@Component({
  selector: 'app-event-power-ups',
  standalone: true,
  imports: [MobileCollapsibleSectionComponent, PowerUpCardComponent],
  templateUrl: './event-power-ups.component.html',
  styleUrl: './event-power-ups.component.scss'
})
export class EventPowerUpsComponent {
  public readonly readonly = input(false)
  public readonly eventVenueCity = input<string>()
  public readonly powerUpClicked = output<EventPowerUpId>()
  public readonly hasPersonas = input(true)

  private readonly _powerUpCards: PowerUpCard[] = [
    {
      id: EventPowerUpId.Crew,
      icon: {
        type: 'svg',
        content: `<svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.9375 4.375C2.70703 4.375 1.75 3.41797 1.75 2.1875C1.75 0.984375 2.70703 0 3.9375 0C5.14062 0 6.125 0.984375 6.125 2.1875C6.125 3.41797 5.14062 4.375 3.9375 4.375ZM14 4.375C12.7695 4.375 11.8125 3.41797 11.8125 2.1875C11.8125 0.984375 12.7695 0 14 0C15.2031 0 16.1875 0.984375 16.1875 2.1875C16.1875 3.41797 15.2031 4.375 14 4.375ZM0 8.17578C0 6.5625 1.28516 5.25 2.89844 5.25H4.07422C4.51172 5.25 4.92188 5.35938 5.30469 5.52344C5.25 5.71484 5.25 5.93359 5.25 6.125C5.25 7.19141 5.6875 8.12109 6.42578 8.75C6.42578 8.75 6.42578 8.75 6.39844 8.75H0.574219C0.246094 8.75 0 8.50391 0 8.17578ZM11.0742 8.75H11.0469C11.7852 8.12109 12.2227 7.19141 12.2227 6.125C12.2227 5.93359 12.2227 5.71484 12.1953 5.52344C12.5508 5.35938 12.9609 5.25 13.3984 5.25H14.5742C16.1875 5.25 17.5 6.5625 17.5 8.17578C17.5 8.50391 17.2266 8.75 16.8984 8.75H11.0742ZM11.375 6.125C11.375 7.57422 10.1992 8.75 8.75 8.75C7.30078 8.75 6.125 7.57422 6.125 6.125C6.125 4.67578 7.30078 3.5 8.75 3.5C10.1992 3.5 11.375 4.67578 11.375 6.125ZM3.5 13.2891C3.5 11.2656 5.11328 9.625 7.13672 9.625H10.3359C12.3594 9.625 14 11.2656 14 13.2891C14 13.6719 13.6719 14 13.2617 14H4.21094C3.82812 14 3.5 13.6992 3.5 13.2891Z" fill="#374151"/></svg>`
      },
      title: 'Crew & Staffing',
      pricing: 'Free',
      description: 'Assign, manage, and coordinate your event staff and teams efficiently.',
      tags: ['Onsite management', 'Staffing tools']
    },
    {
      id: EventPowerUpId.Zones,
      icon: {
        type: 'image',
        src: 'assets/images/v2/zones.png',
        alt: 'Zones'
      },
      title: 'Zone management',
      pricing: 'Free',
      description: 'Manage event zones, approvals, and compliance with authorities.',
      tags: ['Onsite tools']
    },
    {
      id: EventPowerUpId.SelfPrinting,
      icon: {
        type: 'image',
        src: 'assets/images/v2/self-print.svg',
        alt: 'Self Printing'
      },
      title: 'Self Printing',
      pricing: 'Free',
      description: 'Enable on-site services like badge printing and attendee check-in through self-service tools.',
      tags: ['Onsite tools']
    },
    {
      id: EventPowerUpId.EventApps,
      icon: {
        type: 'svg',
        content: `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.25 1.3125V3.9375C5.25 4.67578 4.64844 5.25 3.9375 5.25H1.3125C0.574219 5.25 0 4.67578 0 3.9375V1.3125C0 0.601562 0.574219 0 1.3125 0H3.9375C4.64844 0 5.25 0.601562 5.25 1.3125ZM5.25 8.3125V10.9375C5.25 11.6758 4.64844 12.25 3.9375 12.25H1.3125C0.574219 12.25 0 11.6758 0 10.9375V8.3125C0 7.60156 0.574219 7 1.3125 7H3.9375C4.64844 7 5.25 7.60156 5.25 8.3125ZM7 1.3125C7 0.601562 7.57422 0 8.3125 0H10.9375C11.6484 0 12.25 0.601562 12.25 1.3125V3.9375C12.25 4.67578 11.6484 5.25 10.9375 5.25H8.3125C7.57422 5.25 7 4.67578 7 3.9375V1.3125ZM12.25 8.3125V10.9375C12.25 11.6758 11.6484 12.25 10.9375 12.25H8.3125C7.57422 12.25 7 11.6758 7 10.9375V8.3125C7 7.60156 7.57422 7 8.3125 7H10.9375C11.6484 7 12.25 7.60156 12.25 8.3125Z" fill="#374151"/></svg>`
      },
      title: 'Event apps',
      description: 'Integrate networking and virtual tools for hybrid and digital experiences.',
      tagsIcons: ['assets/images/v2/handshake-logo.svg', 'assets/images/v2/vfairs.png', 'assets/images/v2/microsoft.svg', 'assets/images/v2/zoom.svg']
    },
    {
      id: EventPowerUpId.InvitationTracker,
      icon: {
        type: 'svg',
        content: `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_51794_158449)"><path d="M0.00126454 6.37652V13.5436L4.06918 10.4171C3.95799 10.3059 -0.0818348 6.29331 0.00126454 6.37652Z" fill="#374151"/><path d="M11.5117 3.86743V7.67729L13.571 5.64531L11.5117 3.86743Z" fill="#374151"/><path d="M2.4895 3.86743L0.430176 5.64531L2.4895 7.67729V3.86743Z" fill="#374151"/><path d="M9.93205 10.417L14 13.5435V6.37646C13.9174 6.45892 9.78518 10.5638 9.93205 10.417Z" fill="#374151"/><path d="M7.00047 9.17896L0.751465 13.999H13.2495L7.00047 9.17896Z" fill="#374151"/><path d="M6.73065 0.101578L4.97168 1.69531H9.02945L7.27048 0.101578C7.11592 -0.0338592 6.88521 -0.0338592 6.73065 0.101578Z" fill="#374151"/><path d="M7.12651 4.99629L6.99278 4.7063L6.8598 4.98145C6.80138 5.10278 6.68677 5.1877 6.55379 5.20853L6.11768 5.27624L6.39165 5.54338C6.4882 5.63759 6.53221 5.77335 6.50946 5.90633L6.44655 6.27312L6.77574 6.10008C6.8959 6.03685 7.03764 6.03685 7.15781 6.10008L7.48668 6.27312L7.42377 5.90633C7.40091 5.77335 7.44502 5.63759 7.54147 5.54338L7.80786 5.28394L7.44022 5.23021C7.30275 5.21056 7.18504 5.12244 7.12651 4.99629Z" fill="#374151"/><path d="M10.6917 2.92567C10.6917 2.69913 10.5081 2.51562 10.2816 2.51562H3.71973C3.49318 2.51562 3.30957 2.69913 3.30957 2.92567C3.30957 3.0845 3.30957 8.58369 3.30957 8.4976L4.72322 9.91114L6.75552 8.33856C6.90132 8.23047 7.09999 8.23047 7.24579 8.33856L9.27809 9.91114L10.6917 8.49749C10.6917 6.97394 10.6917 2.92567 10.6917 2.92567ZM8.9756 5.29112L8.26829 5.98038L8.43524 6.95364C8.46173 7.10745 8.39839 7.26286 8.27224 7.3545C8.14525 7.44679 7.97798 7.45833 7.84009 7.3858L6.96658 6.9264L6.09265 7.3858C5.95497 7.45907 5.78792 7.44668 5.66049 7.3545C5.53435 7.26286 5.47111 7.10745 5.4975 6.95364L5.66455 5.98038L4.95724 5.29112C4.84627 5.18292 4.80589 5.02078 4.85268 4.87295C4.89999 4.72481 5.02688 4.61618 5.18037 4.59215L6.21441 4.43118L6.6313 3.56772C6.70062 3.42512 6.86928 3.34181 7.00418 3.33583C7.16279 3.33701 7.30624 3.42993 7.37311 3.57413L7.77803 4.45083L8.74809 4.59183C8.90265 4.61426 9.03082 4.72235 9.07931 4.87092C9.12738 5.01918 9.08732 5.18217 8.9756 5.29112Z" fill="#374151"/></g><defs><clipPath id="clip0_51794_158449"><rect width="14" height="14" fill="white"/></clipPath></defs></svg>`
      },
      title: 'Invitation tracking',
      description: 'Start sending invitations and track their status across the different channels.',
      tags: ['Event permits', 'Event Registration', 'Marketing']
    }
  ]
  public readonly visiblePowerUpCards = computed(() => {
    const baseCards = this.hasPersonas()
      ? this._powerUpCards
      : this._powerUpCards.filter((card) => card.id !== EventPowerUpId.SelfPrinting && card.id !== EventPowerUpId.InvitationTracker)
    const legalPowerUpCard = this._legalPowerUpCard()
    return legalPowerUpCard ? [...baseCards, legalPowerUpCard] : baseCards
  })

  /**
   * Emits the power up clicked event.
   * @param {PowerUpCard} card - The power up card that was clicked.
   */
  public onCardClicked(card: PowerUpCard): void {
    if (this.readonly()) return
    this.powerUpClicked.emit(card.id)
  }

  /**
   * Returns the legal power up card for the event venue city.
   * @returns {PowerUpCard | null} - The legal power up card for the event venue city, or null if no legal power up card is available.
   */
  private _legalPowerUpCard(): PowerUpCard | null {
    const service = this._legalServiceForVenue()
    if (!service) return null

    const title = `${service.toUpperCase()} Connection`
    return {
      id: service,
      icon: {
        type: 'image',
        src: `assets/images/v2/${service}.svg`,
        alt: title
      },
      title,
      pricing: '$0.10 / registrant',
      description: 'Manage event approvals, compliance, and official coordination with authorities.',
      tags: ['Legal requirements']
    }
  }

  /**
   * Returns the legal service for the event venue city.
   * @returns {EventPowerUpId.Dct | EventPowerUpId.Det | null} - The legal service for the event venue city, or null if no legal service is available.
   */
  private _legalServiceForVenue(): EventPowerUpId.Dct | EventPowerUpId.Det | null {
    const venueCity = this.eventVenueCity()?.trim().toLowerCase()
    if (venueCity === 'abu dhabi' || venueCity === 'abu dhabi region') return EventPowerUpId.Dct
    if (venueCity === 'dubai') return EventPowerUpId.Det
    return null
  }
}
